import { get, keyBy } from 'lodash';

import { getFeaturePropsByFeaturePath } from '@commons/utils/features';

export const getBreakagePropertyName = (userRights) => {
  const featureProps = getFeaturePropsByFeaturePath(userRights, '/home');

  return get(featureProps, 'wasteRate', 'turnoverWasteRate');
};

export const getDisplayManufacturerName = (userRights) => {
  const featureProps = getFeaturePropsByFeaturePath(
    userRights,
    '/admin/suppliers/supplier-products',
  );

  return get(featureProps, 'displayManufacturerName', false);
};

export const getHasRecipeVariants = (userRights) => {
  const featureProps = getFeaturePropsByFeaturePath(userRights, '/admin/products/recipes');

  return get(featureProps, 'hasVariants', false);
};

export const getResetStockEveryDayForCentralKitchen = (userRights) => {
  const featureProps = getFeaturePropsByFeaturePath(userRights, '/order/orders');

  return get(featureProps, 'resetStockEveryDayForCentralKitchen', false);
};

export const getRecommendationsNotRoundedUp = (userRights) => {
  const featureProps = getFeaturePropsByFeaturePath(userRights, '/order/orders');

  return get(featureProps, 'recommendationsNotRoundedUp', false);
};

export const getDisableCreation = (userRights) => {
  const featureProps = getFeaturePropsByFeaturePath(userRights, '/backoffice/users/team');

  return get(featureProps, 'disableCreation', false);
};

export const getPrevHorizon = (userRights) => {
  const featureProps = getFeaturePropsByFeaturePath(userRights, '/forecast/forecast/turnover');

  return get(featureProps, 'prevHorizon', {});
};

export const getUseSupplierProductSecondaryPrices = (userRights) => {
  const featureProps = getFeaturePropsByFeaturePath(userRights, '/invoice/invoice-controls');

  return get(featureProps, 'useSupplierProductSecondaryPrices', false);
};

export const getHasTransferDeliveryTime = (userRights) => {
  const featureProps = getFeaturePropsByFeaturePath(userRights, '/stocks/inventories/transfers');

  return get(featureProps, 'hasTransferDeliveryTime', false);
};

export const getDisableResetPassword = (userRights) => {
  const featureProps = getFeaturePropsByFeaturePath(userRights, '/users');

  return get(featureProps, 'disableResetPassword', false);
};

export const getDisableEdition = (userRights) => {
  const featureProps = getFeaturePropsByFeaturePath(userRights, '/users');

  return get(featureProps, 'disableEdition', false);
};

export const getAuthorizedActions = (userRights, path) => {
  const userRightsByPath = keyBy(userRights, 'path');

  return get(userRightsByPath, `[${path}].actions`, []);
};

export const getAuthorizedActionsForPaths = (userRights, paths) => {
  const userRightsByPath = keyBy(userRights, 'path');

  return paths.map((path) => get(userRightsByPath, `[${path}].actions`, [])).flat();
};
